const styles = {
  container: 'overflow-hidden rounded-md',
  wrapper: 'h-full w-full bg-white/10 backdrop-blur-lg rounded-md',
  img: 'h-full w-full rounded-md',
};

type Props = {
  src: string;
  alt: string;
  className?: string;
};

export default function AlbumImage({ src, alt, className }: Props) {
  const bgImageStyles = {
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    overflow: 'hidden',
  };
  return (
    <div
      style={bgImageStyles}
      className={`${className || ''} ${styles.container}`}
    >
      <div className={styles.wrapper}>
        <img
          className={styles.img}
          style={{ objectFit: 'cover' }}
          src={src}
          alt={`${alt} thumbnail`}
        />
      </div>
    </div>
  );
}
